var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 125.43 78.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#3957a7;}.cls-2{fill:#fff;}.cls-3{fill:#f9a533;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 125.43,
    height: 78.39,
    rx: 4.18,
    ry: 4.18
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "57.72 50.97 51.59 50.97 55.42 27.44 61.55 27.44 57.72 50.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M46.44,27.44,40.6,43.62l-.69-3.48h0L37.85,29.56a2.63,2.63,0,0,0-2.91-2.12H25.28l-.11.4a22.81,22.81,0,0,1,6.41,2.69L36.9,51h6.39L53,27.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M94.63,51h5.63l-4.9-23.53H90.43a2.81,2.81,0,0,0-2.83,1.75L78.46,51h6.39l1.27-3.49h7.8Zm-6.74-8.32,3.22-8.81,1.81,8.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.94,33.1,79.81,28a17.71,17.71,0,0,0-5.51-1C71.26,27,64,28.35,64,34.81c0,6.08,8.48,6.15,8.48,9.35s-7.6,2.62-10.11.6l-.91,5.29a17.11,17.11,0,0,0,6.91,1.33c4.18,0,10.49-2.17,10.49-8.06,0-6.12-8.55-6.69-8.55-9.35S76.32,31.65,78.94,33.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M39.91,40.14,37.85,29.56a2.63,2.63,0,0,0-2.91-2.12H25.28l-.11.4a23.73,23.73,0,0,1,9.09,4.56A18.39,18.39,0,0,1,39.91,40.14Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardVisa);
export default __webpack_public_path__ + "static/media/card-visa.a48ba9aceaedc901addc49fd8b21aa58.svg";
export { ForwardRef as ReactComponent };